import { FC } from "react";
import { TaskDMPPayload } from "tm-shared/types";

import { Loading } from "@/components/Loading";
import useAsyncAction from "@/hooks/useAsyncAction";
import { useCompleteTask } from "@/hooks/useCompleteTask";
import { makeCommand, useMakeCommand } from "@/hooks/useRequestQueue";
import { TaskFinishButton } from "@/pages/WorkPlan/Tasks/components/TaskFinishButton";
import { getPhotoIdsFromPhotoTask } from "@/utils/photo/getPhotoIdsFromPhotoTask";

interface TaskFinishProps {
    isAllCompleted: boolean;
    dmpPayloadMap: TaskDMPPayload;
    marketId: string;
    taskId: string;
}

export const TaskFinish: FC<TaskFinishProps> = ({
    isAllCompleted,
    dmpPayloadMap,
    marketId,
    taskId,
}) => {
    const completeTask = useCompleteTask({ marketId, taskId });

    const { makeTaskCompleteCommands, makeUploadPhotoCommands } =
        useMakeCommand();

    const [handleComplete, completeLoading] = useAsyncAction(async () => {
        const photoIds = getPhotoIdsFromPhotoTask(dmpPayloadMap);
        const hasPhoto = photoIds.length > 0;

        const taskCompleteCommands = await makeTaskCompleteCommands({
            params: { taskId, hasPhoto, payload: dmpPayloadMap },
            marketId,
        });

        const commands = [
            ...makeUploadPhotoCommands(photoIds),

            ...taskCompleteCommands,

            makeCommand({
                type: "updatePhotoStorage",
                title: "Синхронізація сховища",
                params: photoIds,
                options: {
                    stopOnError: false,
                },
            }),
        ];

        completeTask({ commands });
    });

    return (
        <>
            <TaskFinishButton
                onClick={handleComplete}
                visible={isAllCompleted}
                padding="8px 16px"
                loading={completeLoading}
            />

            {completeLoading && <Loading title="Завершення задачі" />}
        </>
    );
};
